<script lang="ts">
  import { ConfigStore } from '../../store/config';
  import { _ } from 'svelte-i18n';
  import { fade } from 'svelte/transition';
</script>

<div class="cs-cb-contact" out:fade|global>
  <div class="cs-contact-header cs-contact-header-{$ConfigStore.widgetType}">
    <h2>{@html $ConfigStore.contactFormTitle || $_('contact_form.title')}</h2>
    <!-- <p>{@html $ConfigStore.contactFormSubTitle || $_('contact_form.sub_title')}</p> -->
  </div>
  <div class="wave-wrapp">
    <svg
      class="wave"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 24 150 28"
      preserveAspectRatio="none"
    >
      <defs>
        <path
          id="gentle-wave"
          d="m -160,44.4 c 30,0 58,-18 87.7,-18 30.3,0 58.3,18 87.3,18 30,0 58,-18 88,-18 30,0 58,18 88,18 l 0,34.5 -351,0 z"
        />
      </defs>
      <g class="parallax">
        <use
          xlink:href="#gentle-wave"
          x="50"
          y="0"
          fill="rgba(255, 255, 255, 0.48)"
        />
        <use
          xlink:href="#gentle-wave"
          x="50"
          y="3"
          fill="rgba(255, 255, 255, 0.78)"
        />
        <use
          xlink:href="#gentle-wave"
          x="50"
          y="6"
          fill="rgba(255, 255, 255, 0.8)"
        />
      </g>
    </svg>
  </div>
</div>

{#if $ConfigStore.customCSSUrl}
  {#if $ConfigStore.customCSSIntegrity}
    <link
      href={$ConfigStore.customCSSUrl}
      rel="stylesheet"
      type="text/css"
      integrity={$ConfigStore.customCSSIntegrity}
    />
  {:else}
    <link href={$ConfigStore.customCSSUrl} rel="stylesheet" type="text/css" />
  {/if}
{/if}

<style lang="scss">
  @use './../../../scss/components/themes/header-contact-theme';
</style>
